import React, { useEffect, useRef, useState } from 'react';
import { Eraser } from 'lucide-react';

export const SignaturePad = ({ onChange }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = ref.current;
    const r = c.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    c.width = r.width * dpr;
    c.height = r.height * dpr;
    const ctx = c.getContext('2d');
    ctx.scale(dpr, dpr);
    ctx.lineWidth = 2.4;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.strokeStyle = '#0c1a2b';
  }, []);

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { e.preventDefault(); ref.current.setPointerCapture(e.pointerId); drawing.current = true; const ctx = ref.current.getContext('2d'); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext('2d'); ctx.lineTo(...pos(e)); ctx.stroke(); };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    setEmpty(false);
    onChange(ref.current.toDataURL('image/png'));
  };
  const clear = () => { const c = ref.current; c.getContext('2d').clearRect(0, 0, c.width, c.height); setEmpty(true); onChange(''); };

  return (
    <div className="relative" data-testid="signature-pad">
      <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
        className="w-full h-44 rounded-xl border-2 border-dashed border-stone-300 bg-white touch-none cursor-crosshair" data-testid="signature-canvas"/>
      {empty && <span className="pointer-events-none absolute inset-0 flex items-center justify-center text-stone-400 text-sm">Draw your signature here</span>}
      <div className="absolute left-6 right-6 bottom-10 border-b border-stone-200 pointer-events-none"/>
      <button type="button" onClick={clear} className="absolute top-2 right-2 inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md bg-stone-100 text-stone-600 hover:bg-stone-200" data-testid="signature-clear-btn"><Eraser size={12}/> Clear</button>
    </div>
  );
};
